import React from 'react'
import { Link } from 'react-router-dom'

import Navbar from '../../components/navbar'
import VideoModalOne from '../../components/video-modal-one'
import EducationCounter from '../../components/education-counter'
import VideoModalTwo from '../../components/video-modal-two'
import About from '../../components/about'
import TeamOne from '../../components/team-one'
import Partner from '../../components/partner'
import ClientOne from '../../components/client-one'
import Footer from '../../components/footer'

import bg1 from '../../assets/images/education/Untitled-1.jpg'
import heroImg from '../../assets/images/education/03.png'
import aboutImg from '../../assets/images/education/04.jpg'
import aboutImg2 from '../../assets/images/education/07.jpg'

import { educationCategory } from '../../data/data'

export default function IndexEducation() {
  return (
    <>
    <Navbar navLight={true}/> 

    <section className="bg-half-170 d-flex align-items-center pb-0" style={{backgroundImage:`url(${bg1})`, backgroundPosition:'center', backgroundRepeat:'no-repeat'}}>
      <div className="bg-overlay" style={{opacity: '0.5'}}></div>
      <div className="container">
          <div className="row align-items-center">
              <div className="col-lg-7 col-md-7">
                  <div className="title-heading mt-4">
                      <h1 className="display-3 text-white title-dark fw-normal mb-3"><span className="fw-bold">Let's learn about <br/> Knowledge and abilites</span></h1>
                      <p className="para-desc title-dark text-light">Start work with Leaping. Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                      <div className="watch-video mt-4 pt-2">
                          <Link to="#" className="btn btn-primary me-2">Get Started</Link>
                          <div className="watch-video mt-4 pt-2 d-inline-block">
                              <VideoModalOne textLight={true}/>
                          </div>
                      </div>
                  </div>
              </div>

              <div className="col-lg-5 col-md-5 mt-4 pt-2 mt-sm-0 pt-sm-0">
                  <img src={heroImg} className="img-fluid" alt=""/>
              </div>
          </div>
      </div> 
    </section>

    <EducationCounter/>

    <section className="section"> 
      <div className="container">
          <div className="row align-items-center">
              <div className="col-lg-5 col-md-6">
                  <div className="position-relative">
                      <img src={aboutImg} className="img-fluid shadow-lg rounded-4" alt=""/>
                      <VideoModalTwo/>
                  </div>
              </div>

              <div className="col-lg-7 col-md-6 mt-4 pt-2 mt-sm-0 pt-sm-0">
                  <div className="section-title ms-md-4">
                      <h5 className="text-primary">About Us</h5>
                      <h4 className="title mb-4">Why we are best <br/> from other?</h4>
                      <p className="text-muted">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                      <p className="text-muted">It seems that only fragments of the original text remain in the Lorem Ipsum texts used today. One may speculate that over the course of time certain letters were added or deleted at various positions within the text. This might also explain why one can now find slightly different versions. Due to the age of the Lorem Ipsum text there are no copyright issues to contend with.</p>
                      <Link to="#" className="btn btn-primary">Read More</Link>
                  </div>
              </div>
          </div>
      </div>
    </section>

    <section className="section bg-light">
      <div className="container">
          <div className="row">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <h4 className="title mb-4">Our course by category</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>

          <div className="row">
            {educationCategory.map((item,index)=>{
              let Icon = item.icon
              return(
                  <div className="col-lg-4 col-md-6 col-12 mt-4 pt-2" key={index}>
                      <div className="feature p-4 rounded">
                          <Icon className="text-primary h2"></Icon>
                          <div className="content mt-2">
                              <h4 className="title">{item.title1} <br/> {item.title2}</h4>
                              <p className="text-muted mt-2">{item.desc}</p>
                          </div>
                      </div>
                  </div>
              )
            })}
          </div>
      </div>
    </section>

    <section className="section">
      <div className="container">
         <About/>
      </div>

      <div className="container mt-100 mt-60">
          <div className="row align-items-center">
              <div className="col-md-5 order-1 order-md-2 text-end">
                  <img src={aboutImg2} className="img-fluid shadow-lg rounded-top-pill rounded-bottom-5" alt=""/>
              </div>

              <div className="col-md-7 order-2 order-md-1 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="section-title">
                      <h4 className="title mb-4">We have highly expert & <br/> Experienced tutors</h4>
                      <p className="text-muted">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                      <p className="text-muted">It seems that only fragments of the original text remain in the Lorem Ipsum texts used today. One may speculate that over the course of time certain letters were added or deleted at various positions within the text. This might also explain why one can now find slightly different versions. Due to the age of the Lorem Ipsum text there are no copyright issues to contend with.</p>
                      <div className="mt-4">
                          <Link to="#" className="btn btn-outline-primary">Start Now</Link>
                      </div>
                  </div>
              </div>
          </div>
      </div>

      <div className="container mt-100 mt-60">
          <div className="row">
              <div className="col-12 text-center">
                  <div className="section-title">
                      <h4 className="title mb-4">Our Teacher's Team</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>
          <TeamOne/>
      </div>
    </section>

    <section className="section bg-light">        
      <div className="container">
          <div className="row justify-content-center">
              <div className="col-lg-6 col-md-9 text-center">
                  <ClientOne/>
              </div>
          </div>
      </div>
    </section>

    <section className="section">
      <div className="container">
          <div className="row justify-content-center">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <h4 className="title mb-4">Admission Form</h4>
                      <p className="text-muted mx-auto para-desc mb-0">Splash your dream color Bring your home to lively Colors. We make it a priotity to offer flexible services to accomodate your needs</p>
                  </div>
              </div>
          </div>

          <div className="row align-items-center justify-content-center">
              <div className="col-md-10 mt-4 pt-2">
                  <div className="custom-form bg-white p-4 rounded shadow">
                      <form >
                          <div className="row">
                              <div className="col-lg-6 col-12">
                                  <div className="mb-3">
                                      <label className="form-label small fw-bold" htmlFor="name">Your Name <span className="text-danger">*</span> :</label>
                                      <input name="name" id="name" type="text" className="form-control border rounded" placeholder="First Name :"/>
                                  </div>
                              </div>
                              <div className="col-lg-6 col-12">
                                  <div className="mb-3">
                                      <label className="form-label small fw-bold" htmlFor="email">Your Email <span className="text-danger">*</span> :</label>
                                      <input name="email" id="email" type="email" className="form-control border rounded" placeholder="Your email :"/>
                                  </div> 
                              </div>
                              <div className="col-lg-6 col-12">
                                  <div className="mb-3">
                                      <label className="form-label small fw-bold d-block">Department :</label>
                                      <select className="form-control form-select">
                                          <option value="Subject">Subject</option>
                                          <option value="jee">JEE(IIT-JEE)</option>
                                          <option value="pharmacy">Pharmacy department</option>
                                          <option value="Upsc ">UPSC</option>
                                          <option value="b.Com">B.COM</option>
                                          <option value="B.C.A">B.C.A</option>
                                          <option value="B.B.A">B.B.A</option>
                                      </select>
                                  </div>                                                                               
                              </div>
                              <div className="col-lg-6 col-12">
                                  <div className="mb-3">
                                      <label className="form-label small fw-bold" htmlFor="number">Phone Number :</label>
                                      <input name="number" id="number" className="form-control border rounded" placeholder="+00-123-45-678"/>
                                  </div>                                                                               
                              </div>
                              <div className="col-lg-6 col-12">
                                  <div className="mb-3">
                                      <label className="form-label small fw-bold" htmlFor="date">Date :</label>
                                      <input name="date" id="date" type="date" className="form-control border rounded"/>
                                  </div> 
                              </div>
                              <div className="col-lg-6 col-12">
                                  <div className="mb-3">
                                      <label className="form-label small fw-bold" htmlFor="time">Time :</label>
                                      <input name="time" id="time" type="time" className="form-control border rounded"/>
                                  </div> 
                              </div>
                              <div className="col-12">
                                  <div className="mb-3">
                                      <label className="form-label small fw-bold" htmlFor="comments">Your Address <span className="text-danger">*</span> :</label>
                                      <input name="comments" id="comments" className="form-control border rounded" placeholder="Full Address :"/>
                                  </div>                                                                               
                              </div>
                              <div className="col-12">
                                  <div className="mb-3">
                                      <label className="form-label small fw-bold" htmlFor="comment">Your Message <span className="text-danger">*</span> :</label>
                                      <textarea name="comments" id="comment" rows="4" className="form-control border rounded" placeholder="Your Message :"></textarea>
                                  </div>                                                                               
                              </div>

                              <div className="col-sm-12 text-end">
                                  <button type="submit" id="submit" name="send" className="btn w-100 btn-primary">Submit</button>
                              </div>
                          </div>
                      </form>
                  </div>
              </div>
          </div>
      </div>
    </section>

    <section className="py-5">
      <div className="container">
          <div className="row">
              <Partner/>
          </div>
      </div>
    </section>

    <Footer/>
    </>
  )
}
